import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import HighlightButtonView from './View';
import HighlightButtonBlockData from './Data';

const HighlighButtonEdit = (props) => {
  const { selected } = props;

  return (
    <>
      <HighlightButtonView {...props} isEditMode={true} />
      <div className="flex flex-col gap-y-4 mt-4">
        <h1 className="text-2xl">Vídeo tutorial</h1>
        <iframe
          title="tutorial"
          width="420"
          height="315"
          src="https://www.youtube.com/embed/gA6RBso7MNg"
          className="self-center"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
      <SidebarPortal selected={selected}>
        <HighlightButtonBlockData {...props} />
      </SidebarPortal>
    </>
  );
};

export default HighlighButtonEdit;